module.exports = __webpack_public_path__ + "assets/img/3cc868a18e96a7b5874cd49d911e06a5.png";